import React, { useState, useId } from "react";
import { AnalyticsEvents, trackEvent } from "helpers/analytics/analytics";
import "./StaffMemberCard.css";

const StaffMemberCard = ({ name, position, photo, bio }) => {
  const [expanded, setExpanded] = useState(false);
  const bioId = useId();
  const hasBio = Boolean(bio && bio.trim());

  return (
    <article className="staff-card">
      <div className="staff-card__photo-wrap">
        <img
          className="staff-card__photo"
          src={photo}
          alt={`${name}, ${position} at Ace Gymnastics`}
          width="280"
          height="280"
          loading="lazy"
        />
      </div>
      <div className="staff-card__body">
        <h2 className="staff-card__name">{name}</h2>
        <p className="staff-card__role">{position}</p>

        {hasBio && (
          <>
            <div
              id={bioId}
              className={`staff-card__bio ${expanded ? "is-expanded" : ""}`}
              hidden={!expanded}
            >
              <p>{bio}</p>
            </div>
            <button
              type="button"
              className="staff-card__toggle"
              aria-expanded={expanded}
              aria-controls={bioId}
              onClick={() => {
                setExpanded((v) => {
                  const next = !v;
                  trackEvent(AnalyticsEvents.STAFF_BIO, {
                    item_name: name,
                    location: "staff_page",
                    label: next ? "expand" : "collapse",
                  });
                  return next;
                });
              }}
            >
              {expanded ? "Hide bio" : "Read bio"}
            </button>
          </>
        )}

        {!hasBio && (
          <p className="staff-card__no-bio">Bio coming soon.</p>
        )}
      </div>
    </article>
  );
};

export default StaffMemberCard;
